import React, { useMemo } from 'react';
import { createAdminResource } from 'lib/admin-kit';
import buildConfig from './config';

/**
 * Registered as 'pages/admin/diagnostic_readings/Index' by react-rails.
 * Mounted from AdminKit::DiagnosticReadingsController#index with props:
 *   labels    Server-rendered i18n strings (decisiv.telematics.*)
 *   canCreate Always false (read-only resource)
 */
const Index = ({ labels = {}, ...rest }) => {
  const Resource = useMemo(() => createAdminResource(buildConfig(labels)).Index, [labels]);
  return <Resource {...rest} />;
};

export default Index;
